module.exports = __webpack_public_path__ + "media/images/landing-91680d74.png";